<template>
  <div>

    Välj övning till vänster

  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      'name': 'Övningar'
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/learn/excercises/data/Landing.vue